import { useDispatch } from 'react-redux';
import { Column, ConfirmPopup, Row, Text } from '~/commonComponents';
import { useAppSelector } from '~/hooks/useAppSelector';
import { Colors } from '~/themes/colors';
import NewCSPhoneIcon from '~/images/new-cs-phone.svg';
import PhoneIcon from '~/images/phone.svg';
import { HIDE_CS_CHANGE_POPUP } from '~/actions';
import { NumberUtils } from '~/utils/NumberUtils';

export const CSChangePopup = () => {
  const dispatch = useDispatch();
  const isShowCSChangePopup = useAppSelector((state) => state.user.isShowCSChangePopup);
  if (!isShowCSChangePopup) {
    return;
  }

  return (
    // @ts-expect-error -- ConfirmPopup still written in JavaScript
    <ConfirmPopup
      modalStyle={{ maxWidth: 500, maxHeight: 660, paddingTop: 21 }}
      Icon={() => <img alt="NewCSPhoneIcon" src={NewCSPhoneIcon} />}
      title="Our Customer Success Number is Changing"
      titleStyle={{ color: Colors.black, fontSize: 18, marginBottom: 10 }}
      description={
        <Column alignItems="center">
          <InformationItem text="You can now reach us at:" />
          <Row
            backgroundColor={Colors.secondary_50}
            borderRadius={8}
            paddingHorizontal={15}
            paddingVertical={5}
            marginTop={22}
            gap={4}
          >
            <img alt="NewCSPhoneIcon" src={PhoneIcon} />
            <Text bold>{NumberUtils.getCSPhone().formatted}</Text>
          </Row>
          <InformationItem text="Same top-tier support, just a new number to remember!" />
          <InformationItem text="Make sure to update your contacts, and let us know if you need anything." />
        </Column>
      }
      descriptionStyle={{ color: Colors.neutral_500, marginBottom: 42, width: '85%' }}
      rightButtonText="Got It!"
      rightButtonAction={() => dispatch({ type: HIDE_CS_CHANGE_POPUP })}
    />
  );
};


interface IProps {
  text: string;
}

const InformationItem = ({ text }: IProps) => {
  return (
    <Row gap={10} width="100%" marginTop={22}>
      <Text fontSize={16} color="neutral_500">
        •
      </Text>
      <Text fontSize={16} color="neutral_500" textAlign='left'>
        {text}
      </Text>
    </Row>
  );
};
